/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringIntegrationRetireExpectedVersionExclusiveMin = 0;
export const monitoringIntegrationRetireExpectedVersionMax = 9007199254740991;

export const MonitoringIntegrationRetire = zod.object({
  expectedVersion: zod
    .int()
    .gt(monitoringIntegrationRetireExpectedVersionExclusiveMin)
    .max(monitoringIntegrationRetireExpectedVersionMax),
  confirmed: zod.literal(true),
});

export type MonitoringIntegrationRetire = zod.input<typeof MonitoringIntegrationRetire>;
export type MonitoringIntegrationRetireOutput = zod.output<typeof MonitoringIntegrationRetire>;
